var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: ["collection-frame", _vm.themeColor] }, [
    _c("div", { staticClass: "label-wrapper" }, [_vm._t("label")], 2),
    _c("div", { staticClass: "content-wrapper" }, [_vm._t("content")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }